import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { useAuth, axiosInstance } from '../context/AuthContext';

// Registers this phone for push alerts after sign-in (native app only)
export function PushRegistrar() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user || !Capacitor.isNativePlatform()) return;
    const subs = [];
    const setup = async () => {
      subs.push(await PushNotifications.addListener('registration', ({ value }) => {
        axiosInstance.post('/api/push/register', { token: value, platform: Capacitor.getPlatform() }).catch(() => {});
      }));
      subs.push(await PushNotifications.addListener('pushNotificationActionPerformed', ({ notification }) => {
        const link = notification?.data?.link;
        if (link && link.startsWith('/')) navigate(link);
      }));
      let perm = await PushNotifications.checkPermissions();
      if (perm.receive === 'prompt') perm = await PushNotifications.requestPermissions();
      if (perm.receive === 'granted') await PushNotifications.register();
    };
    setup().catch(() => {});
    return () => subs.forEach(s => s.remove());
  }, [user, navigate]);

  return null;
}
